import axios from "axios";

export const getProductsAndSectors = (
  { commit, dispatch, getters },
  params
) => {
  let coupon = "";
  if (params.coupon) {
    coupon = `?cupom=${params.coupon}`;
    commit("SET_COUPON_APPLIED", params.coupon);
  } else {
    commit("SET_COUPON_APPLIED", null);
    commit("SET_COUPON_DETAILS", null);
  }

  return axios
    .get(`pdv/v3/products/sectors/${params.event}${coupon}`, { params })
    .then(function (response) {
      if (response.status === 200) {
        const { data } = response;

        commit("SET_TIME_TO_VIEW_PRODUCTS", Math.floor(Date.now() / 1000));

        if (
          getters.eventDetails?.site_visibilidade === "Y" &&
          !data.isCupomValid
        ) {
          commit("SET_SHOW_PRE_SALE", true);
          if (coupon)
            dispatch("openSnackbar", {
              message: "Código Inválido.",
              color: "error",
            });
        } else if (
          getters.eventDetails?.site_visibilidade === "Y" &&
          data.isCupomValid
        ) {
          commit("SET_SHOW_PRE_SALE", false);
        }

        dispatch("setProductsDetails", data);
        return response;
      }
    })
    .catch(function (err) {
      if (
        err &&
        err.response &&
        err.response.data &&
        err.response.data.message &&
        (err.response.data.message === "Vendas não iniciadas" ||
          err.response.data.message === "Vendas encerradas")
      )
        commit("SET_ERROR_PRODUCTS", err.response.data.message);
      console.error("Failed loging in", err);
      throw err;
    });
};

function groupBy(collection, property) {
  let i = 0;
  let val;
  let index;
  const values = [];
  const result = [];

  for (i; i < collection.length; i++) {
    val = collection[i][property];
    index = values.indexOf(val);
    if (index > -1) {
      result[index].push(collection[i]);
    } else {
      values.push(val);
      result.push([collection[i]]);
    }
  }
  return result;
}

export const addCartProduct = ({ commit }, product) => {
  commit("ADD_CART_PRODUCT", product);
};

export const removeCartProduct = ({ commit }, product) => {
  commit("REMOVE_CART_PRODUCT", product);
};

export const setProductsDetails = ({ commit, getters, dispatch }, data) => {
  commit("SET_PRODUCTS_DETAILS", data);
  if (data.hasCupom) {
    if (data?.cupomData?.campaign_coupon)
      commit("SET_COUPON_APPLIED", data.cupomData.campaign_coupon);
    commit("SET_COUPON_DETAILS", data);
    if (data.cupomData && data.cupomData.max_order_products)
      commit("SET_MAX_PRODUCTS_PER_COUPON", data.cupomData.max_order_products);
  }
  const sectors = data.sectors;
  var zeroSector = null;

  sectors.forEach((sectors) => {
    if (sectors.codigo === 0) zeroSector = true;

    const products = groupBy(sectors.products, "codigo_produto");

    products.forEach((types) => {
      types.forEach((product) => {
        product.quantidade = 0;
        if (!product.quantidade_minima) product.quantidade_minima = 1;
        if (!product.quantidade_maxima) product.quantidade_maxima = 5;
        product.nome = product.nome.replace("<br>", "");
        product.nome_tipo = product.nome_tipo.replace("<br>", "");
        switch (product.sexo) {
          case "F":
            product.sexo = "Feminino";
            break;
          case "M":
            product.sexo = "Masculino";
            break;
          default:
            product.sexo = "Unissex";
            break;
        }
      });
    });
  });

  if (zeroSector) {
    let noSectorProducts = sectors.filter((el) => el.codigo === 0)[0].products;

    const groupedProducts = groupBy(noSectorProducts, "codigo_produto");
    commit(
      "SET_SEPARATE_PRODUCTS",
      sectors.filter((el) => el.codigo === 0)[0].products
    );
    commit("SET_NOSECTOR_LIST", groupedProducts);
  }
  let sectorsList = sectors.filter((el) => el.codigo !== 0);

  if (getters.selectedSector) {
    let updatedSelectedSector = sectorsList.find(
      (sector) => sector.codigo === getters.selectedSector.codigo
    );

    commit("SET_SELECTED_SECTOR", updatedSelectedSector);
  }

  if (sectorsList.length === 1 && !zeroSector && !getters.selectedSector) {
    let params = {
      event_id: getters.eventDetails.codigo,
      sector_id: sectorsList[0].codigo,
    };

    localStorage.setItem(
      `sector-selected-${getters.eventDetails.codigo}`,
      JSON.stringify(sectorsList[0].codigo)
    );
    localStorage.setItem(`show-map-${getters.eventDetails.codigo}`, "true");

    dispatch("getSeatsSector", params);
    commit("SET_SELECTED_SECTOR", sectorsList[0]);
    commit("SET_SHOW_SEAT_MAP", true);
  }

  commit("SET_SECTORS_LIST", sectorsList);
};

export const createOrder = async ({ commit, dispatch, getters }, cart) => {
  const order = { body: [] };
  const {
    couponApplied,
    cartAbandoned,
    timeToViewProducts,
    screenTimeOn,
    facebookCookies,
  } = getters;

  cart.forEach((product) => {
    product.forEach((tipo) => {
      order.body.push({
        cupom: couponApplied ? couponApplied : null,
        event: tipo.codigo_evento,
        product: tipo.codigo_produto,
        type: tipo.codigo_tipo,
        qtd: tipo.quantidade,
        qtdade_min: tipo.qts_min,
        lot: tipo.lote,
        amount: tipo.valor,
        pay_option: "P",
        seats: tipo.seats ? tipo.seats : "",
      });
    });
  });

  if (cartAbandoned) order.carrinho_abandonado = true;

  if (timeToViewProducts) order.dac = timeToViewProducts;

  if (facebookCookies.fbc) order.fbc = facebookCookies.fbc;
  if (facebookCookies.fbp) order.fbp = facebookCookies.fbp;

  order.tep = screenTimeOn;

  return await axios
    .post(`pdv/orders/create`, order)
    .then((response) => {
      if (response.status === 200 && response.data && !response.data.error) {
        const { valor_total } = response.data;

        if (Math.abs(valor_total - getters.productsTotal) > 0.01) {
          const ht = localStorage.getItem("ht");

          axios.post(`analytics/visits?order=not_available`, {
            event: getters.eventDetails.codigo,
            url: document.URL,
            ht: ht,
            device: window.navigator.userAgent,
            referer: document.referrer,
          });
          return { data: { error: "Lote Esgotado" } };
        }

        let nextRouteName =
          getters.eventDetails.one_checkout === 40 ||
          getters.eventDetails.one_checkout === 42 ||
          getters.eventDetails.checkout_nomeacao_obrigatoria == 2
            ? "Payment"
            : "Participants";
        commit("SET_LAST_ORDER_AND_CART", {
          cart: JSON.stringify(getters.noSectorList),
          selectedSector: JSON.stringify(getters.selectedSector),
          order: JSON.stringify(response.data),
          route: nextRouteName,
        });
        commit("SET_ORDER_DETAILS", response.data);
        return response;
      } else return response;
    })
    .catch((error) => {
      if (error && error.response && error.response.status === 429)
        dispatch("openSnackbar", {
          message: error.response.data.message,
          color: "error",
        });
    });
};

export const getSeatsSector = async ({ commit, dispatch }, params) => {
  return await axios
    .get(`v2/events/seats/list`, { params })
    .then((response) => {
      if (response.status === 200) {
        commit("SET_LIST_SEATS", response.data);
        return response;
      } else return response;
    })
    .catch(() => {
      commit("SET_SELECTED_SECTOR", null);
      dispatch("openSnackbar", {
        message: "Erro ao carregar assentos",
        color: "error",
      });
    });
};

export const checkIfSeatAvailable = async (
  { dispatch, getters },
  selectedSeat
) => {
  return await axios
    .post(
      `v2/events/seats/book?seat_id=${selectedSeat.codigo_assento}${
        getters.couponApplied ? `&coupon=${getters.couponApplied}` : ""
      }`
    )
    .then((response) => {
      if (response.status === 200) {
        return response;
      } else return response;
    })
    .catch(() => {
      dispatch("openSnackbar", {
        message: "Erro ao reservar, assento indisponível.",
        color: "error",
      });
    });
};
